import React, { useRef } from "react";
import {
  VegaFlex,
  VegaCheckbox,
  VegaButton,
  VegaInput,
} from "@heartlandone/vega-react";
import { useEffect, useState } from 'react';
import './index.css';
import { isNumber } from 'Chore/Utils'

const FIRST_STEP = 0;

function StepOne({ isEdit = false, form={}, currentStep, onNextClick = () => {} }) {
  const _isShow = () => currentStep === FIRST_STEP;
  const [title, setTitle] = useState('');
  const [isFree, setIsFree] = useState(false);
  const [canGoNext, setCanGoNext] = useState(false);
  const [numberLimitValue, setNumberLimitValue] = useState(null);
  const [chargeValue, setChargeValue] = useState(null);
  const [chargeType, setChargeType] = useState('Paid');

  const chargeRef = useRef();

  useEffect(() => {
    setCanGoNext(title.trim().length > 0 && (isFree || (!isFree && chargeValue > 0)) && isNumber(numberLimitValue) && numberLimitValue >= 0);
  }, [title, chargeValue, isFree, numberLimitValue]);

  useEffect(() => {
    if (isEdit) {
      setIsFree(form.chargeType === 'Unpaid');
    }
    // eslint-disable-next-line
  }, [form]);

  useEffect(() => {
    if (isEdit && isFree && chargeRef.current) {
      chargeRef.current.value = null;
    }
    setChargeType(isFree ? 'Unpaid' : 'Paid');
  // eslint-disable-next-line
  }, [chargeRef, chargeRef.current, isFree])

  return (
    <VegaFlex className={`m-t-32${_isShow() ? "" : " display-none"}`} direction={"col"} gap="size-24">
        <VegaFlex direction="col" gap="size-24">
          <div className="form-step-title">Basic Info</div>
        </VegaFlex>
      <div className="content-wrapper m-t-24">
        <VegaFlex direction="col" gap="size-24">
          <VegaInput
            label="Title"
            size="small"
            maxLength={200}
            data-vega-form={"title"}
            required={true}
            onVegaChange={e=>{
              setTitle(e.detail);
            }}
          />
          <VegaFlex alignItems={"flex-start"} gap="size-16">
            <VegaInput
              style={{ width: '25%' }}
              type="number"
              size="small"
              label="Activity Cost"
              required={true}
              ref={chargeRef}
              disabled={isFree}
              maxLength={10}
              prefixIcon={'fa-solid fa-dollar-sign'}
              placeholder={isFree ? "Free" : "0"}
              value={chargeValue}
              data-vega-form={"chargeAmount"}
              maskConfig={{ type: `number`, options:{allowNegative:false} }}
              onVegaChange={e => {
                setChargeValue(e.detail);
                if(parseFloat(e.detail) === 0) {
                  setIsFree(true);
                }
              }}
            />
            <VegaInput value={chargeType} style={{ display: 'none' }} data-vega-form={"chargeType"} />
            <VegaCheckbox
              size="default"
              gap="size-24"
              label="Free Activity"
              style={{marginTop: 40}}
              checked={isFree}
              data-vega-form={"isFree"}
              onVegaChange ={(e) => {
                const isFree = e.detail;
                if(isFree){
                  setChargeValue(null)
                }
                setIsFree(isFree);
              }}  
            >
              Free Activity
            </VegaCheckbox>
          </VegaFlex>
          <VegaFlex alignItem={"end"}>
            <VegaFlex gap="size-16" direction={'col'} flex={1}>
              <VegaInput
                label="Maximum Participants"
                type="number"
                style={{ width: '25%' }}
                size="small"
                required={true}
                integerOnly={true}
                disabled={isEdit}
                maxLength={9}
                maskConfig={{ type: `number`, options:{precision:0, allowNegative:false} }}
                data-vega-form={"registerNumberLimit"}
                onVegaChange={e => {
                  if(parseInt(e.detail) <= 0) {
                    setNumberLimitValue(null);
                  }
                  setNumberLimitValue(e.detail);
                }}
              />
              <div className="hints">Set '0' for unlimited</div>
            </VegaFlex>
          </VegaFlex>
        </VegaFlex> 
        <VegaFlex justifyContent='end' alignItem={'center'} className='m-t-80 p-b-48 border-none' style={{marginBottom: -24 }}>
          <VegaFlex gap={'size-12'}>
            <VegaButton label = {"Next"} disabled={!canGoNext} onVegaClick={() => onNextClick('Basic Info')}/>
          </VegaFlex>
        </VegaFlex>
      </div>
    </VegaFlex>
  );
}

export default StepOne;
